import { instance } from '../instance';

export const transferDsIn = (param) => instance.post('transfer/transferDsIn', param);
